<template>
  <div class="upload-row">
    <Upload
        v-if="isEdit"
        class="upload"
        ref="upload"
        :show-upload-list="false"
        :default-file-list="defaultList"
        :on-success="handleSuccess"
        :before-upload="handleBeforeUpload"
        :action="actionUrl"
        :format="['jpg','jpeg','png', 'pdf','xlsx','xls','doc','docx']"
        :on-format-error="handleFormatError"
        :headers="uploadHeaders"
        multiple
        type="drag">
      <div>
        <Icon type="ios-add-circle-outline" size="24" color="#cbcbcb"></Icon>
      </div>
    </Upload>
    <div class="attach" @click="openUploadTable">
      <Icon custom="iconfont icon-fujian" size="24" color="#cbcbcb"></Icon>
      <div class="badge" v-if="uploadList.length > 0">{{uploadList.length}}</div>
    </div>
    <vxe-modal v-model="showUploadTable" width="1000" height="350" title="上传附件" position="center">
      <upload-table ref="uploadTable" style="margin-top: 20px;" :row="row"
                    @fileList="getUploadImgFileList" :isEdit="isEdit"></upload-table>
    </vxe-modal>
  </div>
</template>
<script>
  import auth from "@/utils/auth";
  import UploadTable from "@/components/modal/UploadTable";

  const union = (...arr) => [...new Set(arr.flat())];
  const assign = (o) => Object.assign({}, o);
  const empties = [undefined, "", null, "null", {}, []];

  export default {
    components: {
      UploadTable
    },
    props: {
      row: {
        type: Object,
        default: null,
      },
      initFileList: {
        type: Array,
        default: null,
      },
      isEdit: {
        type: Boolean,
        default: true,
      },
      maxLength: {
        type: Number,
        default: 5
      },
    },
    data() {
      return {
        showUploadTable: false,
        uploadList: [],
        defaultList: [],
        actionUrl: "", // 初始化上传地址
        uploadHeaders: {
          Authorization: auth.getAuth().token,
          token: auth.getAuth().token,
        },
      }
    },
    watch: {
      initFileList: {
        deep: true,
        immediate: true,
        handler: function (val, oldVal) {
          this.init(val);
        },
      },
    },
    mounted() {
      this.actionUrl = process.env.VUE_APP_API + "/api/tool/oss/upload";
    },
    methods: {
      getUploadImgFileList(fileList) {
        this.init(fileList);
      },
      openUploadTable() {
        this.showUploadTable = true;
        this.$refs.uploadTable.setList(this.uploadList);
      },
      init(initFileList) {
        // 编辑时 设置response属性
        this.uploadList = [];
        this.defaultList = [];
        if (initFileList && initFileList.length > 0) {
          let list = JSON.parse(JSON.stringify(initFileList));
          list.forEach((item) => {
            item.status = "finished";
            item.percentage = 100;
            if (empties.includes(item.oldFileName)) {
              item.oldFileName = item.oldName;
            } else {
              item.oldName = item.oldFileName;
            }
            item.name = item.oldName ? item.oldName : item.response.data ? item.response.data.oldName : null;
            if (empties.includes(item.response)) {
              item.response = {};
              item.response.data = {};

              let url = item.url ? item.url : item.response.data.url;
              let uuid = item.uuid ? item.uuid : item.response.data.uuid;
              let oldName = item.oldName ? item.oldName : item.response.data.oldName;
              item.response = {
                data: {
                  url,
                  uuid,
                  oldName,
                },
              };
            }
            this.defaultList.push(assign(item));
          });
        }
        this.uploadList = union(this.uploadList, this.defaultList);
        this.returnFileUuidList();
      },
      handleFormatError(file) {
        this.$Notice.warning({
          title: "文件格式不正确",
          desc:
            "文件 " +
            file.name +
            " 格式不正确，请上传 jpg 或 png 或 jpeg 格式的图片, pdf、doc、docx、xlsx、xls格式的文件。",
        });
      },
      handleSuccess(res, file) {
        if (res && res.status === 200 && res.data) {
          if (this.uploadList.length > 1) {
            this.showMore = true;
          }
          this.returnFileUuidList();
        } else {
          this.$XModal.alert({
            message: res.message ? res.message : "接口异常",
            status: "error",
          });
        }
      },
      handleBeforeUpload(file) {
        if (file.size > 3072000) {
          this.$XModal.alert({
            message: "单个附件大小不能超过3M，请压缩后上传",
            status: "error",
          });
          return false;
        }
        // let maxFileNum = this.maxLength ? this.maxLength : 5;
        // if (this.$refs.upload.fileList.length > maxFileNum) {
        //   this.$XModal.alert({
        //     message: "最多只能上传" + maxFileNum + "张",
        //     status: "error",
        //   });
        //   return false;
        // }
        this.uploadList = this.$refs.upload.fileList;
      },
      returnFileUuidList() {
        let uuidList = [];
        this.uploadList.forEach((item) => {
          if (item.response && item.response.data) {
            uuidList.push(item.response.data.uuid);
          } else {
            uuidList.push(item.uuid);
          }
        });
        this.row.fileUuidList = uuidList;
        this.row.fileNewList = this.uploadList;
      },
    }
  }
</script>
<style scoped>
  @import "~assets/icon/icon-attach/iconfont.css";

  .upload-row {
    display: flex;
    align-items: center;
    justify-content: center;
  }

  .upload {
    margin-left: -15px;
  }

  .upload >>> .ivu-upload-drag {
    border: none;
    background: transparent;
  }

  .attach {
    margin-left: 10px;
    height: 100%;
    position: relative;
    cursor: pointer;
  }

  .badge {
    width: 18px;
    height: 18px;
    background: red;
    font-size: 10px;
    color: white;
    text-align: center;
    border-radius: 10px;
    display: flex;
    align-items: center;
    justify-content: center;
    position: absolute;
    top: 0px;
    right: 0px;

    transform: translateX(50%);
    border: 1px solid transparent;
    white-space: nowrap;
    transform-origin: -10% center;
    z-index: 10;
    box-shadow: 0 0 0 1px #fff;

    font-family: Monospaced Number, sans-serif;
    vertical-align: middle;
    padding-right: 3px;
    box-sizing: border-box;
  }
</style>